module.exports = __webpack_public_path__ + "img/stores_legal@1x.8fad985.jpg";